













import { Component, Prop, Vue, Watch, Mixins, Emit } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class ApexChart extends Vue {
    /**
     * Chart data
     */
    @Prop({ type: Array, default: () => [] })
    public chartData!: any[];

    @Prop({ type: Number, default: 10 })
    xMax!: number;
    /**
     * Chart data
     */
    @Prop({ type: Array, default: () => [] })
    public labels!: any[];

    /**
     * Reset chart
     */
    @Prop({ type: Boolean, default: false })
    public resetChart!: boolean;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: String })
    public name!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: String, default: 'bar' })
    public chartType!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Object, default: () => ({}) })
    public chartOptions!: any;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 600 })
    public height!: number;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Number, default: 400 })
    public width!: number;

    /**
     * Chart options(If override default options)
     */
    @Prop({ type: Boolean, default: false })
    stacked!: boolean;

    /**
     * ApexCharts data
     */
    private options: any = {};
    private series: any[] = [];

    /**
     * initialize
     */
    mounted() {
        console.log('mounted()');
        console.log(this.labels);
        console.log(this.chartData);
    }

    /**
     * Watching for changes to the chartData property
     */
    @Watch('chartData', { deep: true, immediate: true })
    onChangeChartData() {
        if (!Object.keys(this.chartOptions).length) {
            this.options = this.applyDefaultOptions();
        } else {
            this.options = this.chartOptions;
        }
        // check if this is a stacked chart
        // if it's an array, directly change this.series = chart-data
        if (this.stacked) {
            this.series = this.chartData;
        } else {
            this.series = [
                {
                    name: this.name,
                    data: this.chartData,
                },
            ];
        }

        console.log('onChangeChartData()');
        console.log(this.series);
        console.log(this.options);
    }

    /**
     * Default Options
     */
    private applyDefaultOptions() {
        return {
            chart: {
                height: this.height,
                width: this.width,
                type: this.chartType,
                redrawOnWindowResize: false,
                redrawOnParentResize: false,
                offsetY: 0,
                toolbar: {
                    show: false,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true || '<img src="/static/icons/reset.png" width="20">',
                        customIcons: [],
                    },
                    export: {
                        csv: {
                            filename: undefined,
                            columnDelimiter: ',',
                            headerCategory: 'category',
                            headerValue: 'value',
                            dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString();
                            },
                        },
                        svg: {
                            filename: undefined,
                        },
                        png: {
                            filename: undefined,
                        },
                    },
                    autoSelected: 'zoom',
                },
                stacked: this.stacked,
            },
            colors: this.stacked? undefined: ['#0A4B71'],
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        position: 'center', // top, center, bottom
                    },
                    // endingShape: 'round', // flat, rounded // deprecated
                    columnWidth: '100%',
                    barHeight: '75%',
                },
            },
            dataLabels: {
                enabled: false,
                formatter: function (val: any) {
                    return String(val ? val.toFixed(1) : '');
                },
                offsetY: 0,
                style: {
                    fontSize: '12px',
                    colors: ['#ffffff'],
                },
            },

            xaxis: {
                min: 0,
                max: this.xMax,
                categories: this.labels,
                position: 'bottom',
                labels: {
                    show: true,
                    style: {
                        colors: ['#0A4B71'],
                        fontSize: '10px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                        cssClass: 'apexcharts-xaxis-label',
                    },
                },
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: false,
                },
                crosshairs: {
                    fill: {
                        type: 'gradient',
                        gradient: {
                            colorFrom: '#D8E3F0',
                            colorTo: '#BED1E6',
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                axisBorder: {
                    show: true,
                },
                axisTicks: {
                    show: true,
                },
                labels: {
                    show: true,
                    style: {
                        colors: ['#0A4B71'],
                        fontSize: '10px',
                        fontFamily: 'Nunito, Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                        cssClass: 'apexcharts-yaxis-label',
                    },
                    offsetY: 0,
                },
            },
            title: {
                text: this.name,
                floating: true,
                offsetY: 16,
                offsetX: 102,
                align: 'left',
                style: {
                    color: '#0A4B71',
                },
            },
            tooltip: {
                enabled: true,
            },
            grid: {
                show: true,
                borderColor: '#0A4B7166',
                strokeDashArray: 0,
                position: 'back',
                xaxis: {
                    lines: {
                        show: true,
                    },
                },
                yaxis: {
                    lines: {
                        show: false,
                    },
                },
                row: {
                    colors: undefined,
                    opacity: 0.5,
                },
                column: {
                    colors: undefined,
                    opacity: 0.5,
                },
                padding: {
                    top: 16,
                    right: 0,
                    bottom: 16,
                    left: 0,
                },
            },
        };
    }

    /**
     * onClick
     */
    private onClick(event?: MouseEvent | undefined, activeElements?: {}[] | undefined): any {}

    /**
     * Reset chart position
     */
    @Watch('')
    private resetChartPosition() {}

    /**
     * click a chart element
     */
    @Emit('click-chart-element')
    public clickChartElement(element: any) {
        return element;
    }
}
